<template>
    <div>
        <navigation-bar Close/>
        <div v-show="MealInfo.length > 0" class="main">
            <!--TODO:廣告輪播-->
            <banner :list="MealInfo" :store="Number(0)" class="BN"/>
            <div class="container">
                <h4 class="line mt-4">{{name}}</h4>
                <div class="red" v-show="price > 0">
                    NT$ {{price}}
                </div>
                <div class="text-content mb-4" v-html="content"/>
            </div>
        </div>

        <loading
            :active.sync=isLoading
            :can-cancel="false"
            :is-full-page="true">
        </loading>
    </div>

</template>

<script>
    import Banner from '@/components/BannerSlider.vue';
    import {notNull} from "@/util/common";

    export default {
        name: "MealInfo",
        props: {
            isWeb: Boolean,
            dataTokenWeb: {default: ''},
        },
        components: {
            Banner,
        },
        data() {
            return {
                isLoading:false,
                mealId: this.isWeb ? Number(this.dataTokenWeb.mealId || 0) : Number(this.$route.query.mealId || 0),
                type: this.isWeb ?( this.dataTokenWeb.type || '') : (this.$route.query.type || ''),
                MealInfo:[],
                content:'',
                price:0,
                name:'' ,
            }
        },
        created() {
            if(this.mealId !== 0) {
              this.setupData();
            } else {
              this.$router.go(-1);
            }
        },
        mounted() {
            //
            // window.cordova.InAppBrowser.open('https://www.google.com/maps/@22.6323037,120.2926003,16z', '_system');
        },
        methods: {

            setupData: function () {
                this.isLoading = true;
                //廣告輪播
                this.$http.fetch`GetCommodityData${{
                    'id':   this.mealId,
                    'type': this.type,
                }}
                ${json => {
                    if (notNull(json.data)) {
                        if (notNull(json.data.imgList)) {
                            this.MealInfo = json.data.imgList.map(function (item) {
                                return {
                                    'imgUrl': item,
                                    'url': '',
                                };
                            });
                            this.content = json.data.content;
                            this.price = json.data.price;
                            this.name = json.data.name;
                        }
                    }
                    this.isLoading = false;
                }}`;
            },
            scrollToTop: function () {
                window.scrollTo(0, 0);
            }
        }
    }
</script>
<style lang="less" scoped>
    //圖片輪播尺寸
    /deep/.swiper-container .pic{
        height: calc(100vw - 40px);
        max-height: 984px;
        border-radius: 10px;
        margin: 0;
        @media(min-width: 1024px){
            width: 480px;
            height: 480px;
        }
    }
    /deep/.swiper-container{
        @media(min-width: 1024px){
            width: 480px;
            height: 480px;
            margin-right: 0;
        }
    }
    .main{
        @media(min-width: 768px){
            display: flex;
            flex-wrap: nowrap;
            h4.line{
                font-size: 24px;
                margin-top: 5px !important;
                border-left: none;
                padding-left: 0;
            }
            .red{
                font-size: 24px;
                font-weight: 500;
                height: 35px;
                line-height: 35px;
                margin-bottom: 20px;
            }
        }
    }
    .BN{
        padding-right: 20px;
        padding-left: 20px;
        @media(min-width: 1024px){
            padding: 0;
        }
    }
</style>
